import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import { RETIREMENT_DRAWDOWN_YEARS } from "web_myplann/Inspiration/Retirement/constants";
import type {
	RetirementContext,
	RetirementGoalPreset,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const mapRetirementGoalPreset = (
	context: RetirementContext,
): RetirementGoalPreset => ({
	monthlyRent: context.desiredIncome,
	statePension: context.statePension,
	rentYears:
		context.drawdownMode === RentDrawdownMode.ToZero
			? RETIREMENT_DRAWDOWN_YEARS
			: undefined,
	drawdownMode: context.drawdownMode,
	dueDate: context.retirementDate,
});
